import styled, { css } from 'styled-components';

export const StyledButtonLarge = styled.button(
  ({
    theme,
    backgroundColor = 'oxfordBlue',
    rounded = false,
    loading = false,
  }) => css`
    display: flex;
    align-items: center;
    justify-content: ${loading ? 'center ' : 'space-between'};
    padding: 0px ${theme.spacing.sm};
    width: ${theme.width.full};
    background-color: ${theme.colors[backgroundColor]};
    border: none;
    border-radius: ${rounded ? theme.radius.xl : theme.radius.s};
    height: ${theme.height.h6};
  `
);

export const StyledButtonLargeOutlined = styled.button(
  ({
    theme,
    backgroundColor = 'oxfordBlue',
    inverted,
    rounded = false,
    loading = false,
  }) => css`
    display: flex;
    align-items: center;
    justify-content: ${loading ? 'center ' : 'space-between'};
    padding: ${theme.spacing.none} ${theme.spacing.sm};
    background-color: ${inverted
      ? theme.colors.white
      : theme.colors[backgroundColor]};
    width: ${theme.width.full};
    border: 1px solid
      ${inverted ? theme.colors[backgroundColor] : theme.colors.white};
    border-radius: ${rounded ? theme.radius.xl : theme.radius.s};
    height: ${theme.height.h6};
  `
);

export const StyledButtonLargeDisabled = styled.button(
  ({ theme, rounded = false }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${theme.spacing.none} ${theme.spacing.sm};
    background-color: ${theme.colors.dimGray};
    width: ${theme.width.full};
    border-width: 1px;
    border-radius: ${rounded ? theme.radius.xl : theme.radius.s};
    height: ${theme.height.h6};
    opacity: 0.3;
  `
);
